import { http } from '@/core/api/';

const apiUrl = 'api/pei/transitionstudent';

export default {
  async getFunctionalSkills(studentSieid, weeks = null) {
    let url = `${apiUrl}/functionalskills/${studentSieid}`;

    if (weeks && weeks.length > 0) {
      const weekParams = weeks.map((week) => `weeks=${week}`).join('&');
      url = `${url}?${weekParams}`;
    }

    return await http.get(url);
  },
  async getActivities(model) {
    return await http.get(`${apiUrl}/activities`, {
      params: model,
    });
  },
  async getStatusLog(model) {
    return await http.get(`${apiUrl}/statuslog`, {
      params: model,
    });
  },
  async getDisciplineByTypes(params) {
    let url = `${apiUrl}/getdisciplinebytype?`;

    params = params || {};
    params.serviceTypeIds = params.serviceTypeIds || [];

    params.serviceTypeIds.forEach((serviceTypeId) => {
      url += `&serviceTypeIds=${serviceTypeId}`;
    });
    url = url.replace('?&', '?');
    const { status, data: response } = await http.get(url);
    return status !== 200 ? [] : response;
  },
  async getAvailableDocument(studentSieId, disciplineTypeId) {
    return await http.get(`${apiUrl}/availabledocumentbackup/${studentSieId}`, {
      params: { disciplineTypeId },
    });
  },
  async getSelectedDocuments(transitionStudentId, areaId, subAreaId) {
    return await http.get(
      `${apiUrl}/selecteddocumentbackup/${transitionStudentId}`,
      {
        params: { areaId, subAreaId },
      }
    );
  },
  async getDetailSAEE12a(params) {
    return await http.get(`${apiUrl}/detailsaee12a`, { params });
  },
  async getAllSAEE12(params) {
    return await http.get(`${apiUrl}/saee12`, { params });
  },
  async submitTransitionStudent(payload) {
    return http.post(`${apiUrl}/savetransitionstudent`, payload);
  },
  async getDetail12b(params) {
    return await http.get(`${apiUrl}/detail12b/${params}`);
  },
  async cancelSAEE12(params) {
    return await http.post(`${apiUrl}/cancelsaee12`, params);
  },
  async returnStatusSAEE12(params) {
    return await http.post(`${apiUrl}/returnstatussaee12`, params);
  },
  async getAlternativeLocationTeacherStudents(params) {
    return await http.get(`${apiUrl}/studentsbyteacher`, {
      params,
    });
  },
  async cancelSAEE12b(params) {
    return await http.post(`${apiUrl}/cancel12b`, params);
  },
  async submitSAEE12a(params) {
    return await http.post(`${apiUrl}/savesaee12a`, params);
  },
  async submitSAEE12(params) {
    return await http.post(`${apiUrl}/savesaee12`, params);
  },
  async getStudent(sie) {
    return await http.get(`${apiUrl}/student/${sie}`);
  },
  async getLanguages() {
    return await http.get(`${apiUrl}/languages`);
  },
  async saveStudentSAEE12(sie) {
    return await http.post(`${apiUrl}/addstudentsaee12/${sie}`);
  },
  async getSaee12(id) {
    return await http.get(`${apiUrl}/saee12/${id}`);
  },
  async saveDiscussion(payload) {
    return http.post(`${apiUrl}/discuss`, payload);
  },
  async replaceDiscussionDocument(payload) {
    return http.post(`${apiUrl}/replacedocument`, payload);
  },
  async getAvailableSignatureOptions() {
    return await http.get(`api/signature/availablepositionsTab9`);
  },
  async getParticipationTypeList() {
    return await http.get(`api/pei/participationTypeList`);
  },
  async getAlternateParticipationTypeList() {
    return await http.get(`api/pei/alternateParticipationTypeList`);
  },
  async getSaee12ByStudent(studentSieId) {
    return await http.get(`${apiUrl}/saee12bystudent/${studentSieId}`);
  },
  async getSaee12ForEgress(studentSieId) {
    return await http.get(`${apiUrl}/saee12foregress/${studentSieId}`);
  },
  async changeToNewStatusSaee12(payload) {
    return await http.put(`${apiUrl}/changetonewstatussaee12`, payload);
  },
};
